// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GIb30FV2zEck58OolUBp{justify-content:space-between;align-items:center;column-gap:4px;height:24px;display:flex}.GIb30FV2zEck58OolUBp .em6aCjp3UoUwUsyOuGBT{justify-content:center;align-items:center;width:16px;height:16px;display:flex}.IgjXZRF93X0KHGFxggt4{gap:4px;display:flex}.WKg6bO_7ilo1hKsi1c90{color:var(--content-primary-secondary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapLabel": `GIb30FV2zEck58OolUBp`,
	"questionIcon": `em6aCjp3UoUwUsyOuGBT`,
	"boxLabel": `IgjXZRF93X0KHGFxggt4`,
	"labelText": `WKg6bO_7ilo1hKsi1c90`
};
export default ___CSS_LOADER_EXPORT___;
